// extracted by mini-css-extract-plugin
export var bold = "Heading-module--bold--BgmTT";
export var center = "Heading-module--center--GN84N";
export var h1 = "Heading-module--h1--WbkI6";
export var h2 = "Heading-module--h2--ltUwN";
export var h3 = "Heading-module--h3--EuPku";
export var h4 = "Heading-module--h4--HxSyM";
export var noMargin = "Heading-module--noMargin---Qbna";
export var root = "Heading-module--root--T9xqV";